export default function UmrahGroupSection() {
  const handleRequestFare = () => {
    const message = 'Hello Alwaz Travels, I would like to request Umrah group flight fares';
    window.open(`https://wa.me/447362505895?text=${encodeURIComponent(message)}`, '_blank');
  };

  const features = [
    {
      icon: 'ri-group-line',
      title: 'Group Discounts',
      description: 'Special rates for groups of 10+ passengers traveling together',
    },
    {
      icon: 'ri-calendar-event-line',
      title: 'Ramadan Specials',
      description: 'Exclusive Umrah fares during Ramadan and peak seasons',
    },
    {
      icon: 'ri-team-line',
      title: 'Family Packages',
      description: 'Discounted family fares with flexible payment options',
    },
    {
      icon: 'ri-flight-takeoff-line',
      title: 'Custom Departures',
      description: 'Organize group departures from multiple UK airports',
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-[#14B8A6]/5 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              Umrah Group Flights & Family Booking Specialists
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              We specialize in organizing Umrah group flights with exclusive negotiated fares for religious travel. 
              Whether you're traveling with family or organizing a community group, we offer competitive rates and 
              personalized service to make your sacred journey affordable and comfortable.
            </p>

            <div className="space-y-4 mb-8">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#14B8A6] to-[#0F9688] rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${feature.icon} text-white text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1">{feature.title}</h3>
                    <p className="text-sm text-gray-600">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <button
              onClick={handleRequestFare}
              className="bg-[#14B8A6] text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-[#0F9688] transition-all duration-300 flex items-center gap-3 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              Request Umrah Fare
            </button>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl h-[600px] w-full">
              <img
                src="https://public.readdy.ai/ai/img_res/25e3f905e47eb4ecd3c2a15db2335db7.jpg"
                alt="Umrah Group Travel"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
            </div>

            <div className="absolute bottom-8 left-8 right-8 bg-white/95 backdrop-blur-sm rounded-xl p-6 shadow-xl">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-14 h-14 bg-gradient-to-br from-[#14B8A6] to-[#0F9688] rounded-full flex items-center justify-center">
                  <i className="ri-star-line text-white text-2xl"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900">5,000+</div>
                  <div className="text-sm text-gray-600">Umrah Pilgrims Served</div>
                </div>
              </div>
              <p className="text-sm text-gray-600">
                Trusted by thousands of families for their sacred journey to Mecca and Medina
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
